import React from "react";
import P7 from "../p7";
import { IPopupResultHistoryProps } from "@/types/PopupResultHistoryTypes";

export default class M36 extends React.PureComponent<IPopupResultHistoryProps> {
    render() {
        return <P7 {...this.props} />;
    }
}